(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/betslip/betslip-content.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/betslip/betslip-content.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.betslip_content = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"rows\"></div>\n\n<div class=\"sportkryss\"></div>\n\n<div class=\"weeks\"></div>\n";
},"useData":true});
Handlebars.partials['svs-maltipset-betslip_content'] = svs.maltipset.templates.betslip_content;
})(svs, Handlebars);

 })(window);